export enum PaymentCategoryEnum {
  PAY_INSURANCE_PREMIUM = "pay_insurance_premium",
}
